import { type PropsWithChildren } from 'react'

import { useLoggedOutRoute } from '@/components/hooks/useLoggedOutRoute'

export const LoggedOutRoute = ({ children }: PropsWithChildren) => {
  const { isSignedIn, isHandlingDisabledOrg } = useLoggedOutRoute()

  if (isSignedIn || isHandlingDisabledOrg) {
    return null
  }

  return <>{children}</>
}
